export enum OrderScreens {
    CustomizationScreen = 1,
    SideAndDrinkScreen = 2
}
